import { IPublicCompany, industryImageMapping, industryMapping, getKeyByValue } from 'domain/entities/Company/Company';
import { mqUser } from 'utils/responsive';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import NoImage from 'ui/images/no_image_case.png';

interface CompanyCardProps {
    company: IPublicCompany;
}

const Wrapper = styled.div`
    position: relative;
    width: calc(33% - 30px);
    height: 380px;
    background-color: var(--white);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 13px;
    min-width: 220px;
    min-height: 330px;
    max-width: 340px;
    cursor: pointer;
    border: 1px solid var(--main-color-blue);

    ${mqUser('SP')} {
        width: 80%;
        min-width: 320px;
        margin: 0 auto;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 20px;
`;

const Item = styled.div`
    display: flex;
    gap: 10px;
    align-items: center;
`;

const Title = styled.div`
    font-size: var(--font-medium);
    font-weight: var(--font-bold);
`;

const Content = styled.div`
    font-size: var(--font-medium);
    font-weight: var(--font-bold);
`;

const Industry = styled.div`
    font-size: var(--font-x-large);
    font-weight: var(--font-bold);
    color: var(--main-color-blue);
    margin: 10px 0;
`;

const ImageContainer = styled.div`
    position: relative;
    height: 170px;
`;

const Image = styled.img`
    border-radius: 13px 13px 0 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const Label = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    padding: 8px 10px;
    background-color: var(--main-color-blue);
    color: var(--white);
    font-size: var(--font-medium);
    font-weight: var(--font-bold);
    border-radius: 13px 0 13px 0;
`;

const getIndustryImage = (industry: string | null) => {
    if (!industry) {
        return NoImage;
    }
    const industryKey = getKeyByValue(industryMapping, industry);
    const industryImage = industryImageMapping[industryKey as keyof typeof industryImageMapping];
    return industryImage;
};

export const CompanyCard: React.FC<CompanyCardProps> = ({ company }) => {
    const navigate = useNavigate();
    const industryImage = getIndustryImage(company.industry);

    return (
        // TODO 売り手ユーザーが見れる詳細ページ作る
        // <Wrapper onClick={() => navigate(`/agent/companies/${company.id}/`)}>
        <Wrapper>
            <ImageContainer>
                <Image src={industryImage} alt={company.industry} />
            </ImageContainer>
            <ContentWrapper>
                <Item>
                    <Industry>{company.industry}</Industry>
                    {company.label && <Label>{company.label}</Label>}
                </Item>
                <Item>
                    <Title>エリア：</Title>
                    <Content>
                        {company.area} / {company.prefecture}
                    </Content>
                </Item>
                <Item>
                    <Title>従業員規模：</Title>
                    <Content>{company.number_of_employees}</Content>
                </Item>
                <Item>
                    <Title>売上高：</Title>
                    <Content>{company.revenue_scale}</Content>
                </Item>
                <Item>
                    <Title>営業利益：</Title>
                    <Content>{company.profit_level}</Content>
                </Item>
                <Item>
                    <Title>純資産金額：</Title>
                    <Content>{company.net_assets_level}</Content>
                </Item>
            </ContentWrapper>
        </Wrapper>
    );
};
